import { Pipe, PipeTransform } from '@angular/core'

export type SortByCompareFn<T> = (a: T, b: T) => number

@Pipe({
  name: 'sortBy',
})
export class SortByPipe implements PipeTransform {
  transform<T>(value: T[] | undefined | null, compareFn: SortByCompareFn<T>): T[] {
    return (value ?? []).slice().sort(compareFn)
  }
}
